module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/websocket/lib/version.js
// module id = ./node_modules/websocket/lib/version.js
// module chunks = 3